// DEFAULT: 테이블매니저 홈페이지 전체, 솔루션 체험하기 팝업
// KT: KB, TM, CASHNOTE

export const PAGE_CHANNEL_CODE = {
  DEFAULT: 'C01R40AK0GH',
  KT: 'C04GZN71YAD',
};
